import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "../App.css";

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="lang-toggle" role="group" aria-label="Language">
      <button
        className={language === "en" ? "active" : ""}
        onClick={() => setLanguage("en")}
        aria-pressed={language === "en"}
      >
        EN
      </button>
      <button
        className={language === "bg" ? "active" : ""}
        onClick={() => setLanguage("bg")}
        aria-pressed={language === "bg"}
      >
        BG
      </button>
    </div>
  );
};

export default LanguageToggle;
